<template>
  <span class="jm-education-select">
    <jm-dict-select
      class="jm-input-common2"
      v-bind="$attrs"
      type="online"
      dict-type="education"
      v-model="top"
      @change="changTop"
    />
    <jm-dict-select
      class="jm-input-common2"
      v-bind="$attrs"
      type="online"
      dict-type="edu_detail"
      :refresh.sync="refreshDetail"
      :filter="filter"
      @change="changeSub"
      v-model="sub"
    />
  </span>
</template>

<script>
import jmDictSelect from './dictSelect.vue';

export default {
  name: 'JmEducationSelect',
  components: {
    jmDictSelect
  },
  model: {
    event: 'change',
  },
  props: {
    value: {
      type: Array,
      default: () => {
        return [null, null];
      }
    },
  },
  data() {
    return {
      top: null,
      sub: null,
      refreshDetail: false,
      inited: false,
    };
  },
  methods: {
    /**
     * 获取匹配的教育详情
     *
     * @author Cong Peijun <congpeijun@jiemo.net>
     * @param  {Object} item [description]
     * @return {Boolean}      [description]
     */
    filter(item) {
      if (this.top === item.pid) {
        return true;
      }
      return false;
    },
    changTop(v) {
      // 刷新详情
      this.refreshDetail = true;
      this.sub = null;
      this.$emit('change', [v, this.sub]);
    },
    changeSub(v) {
      this.$emit('change', [this.top, v]);
    }
  },
  created() {
    this.value[0] && (this.top = this.value[0]);
    this.value[1] && (this.sub = this.value[1]);
  },
  watch: {
    value(val) {
      this.top = val[0];
      this.sub = val[1];
    }
  }
};
</script>
